import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore, createMigrate } from "redux-persist";
import thunk from "redux-thunk";

import rootReducer from "./rootReducer";

const migrations = {
  // Bump version and return a new state to invalidate old persisted shape
  1: (state) => {
    // If you want to fully clear cache on this migration, return an empty object
    return {};
  },
};

const persistConfig = {
  key: "root",
  storage,
  version: 1, // increment when you change reducer shape or key casing
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export const persistor = persistStore(store);
